import React , {useState,useEffect ,useContext,useRef,useCallback} from 'react'
import { DeviceContext } from '../photosMain';
import { Link ,useNavigate,useLocation} from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import '../../../styles/photosAlbums.css'
import Skeleton from '../skelton';
import SingleRelatedSection from '../photosSingle/singleRelatedSection';
import PageAds from '../../common/pageAds';

const PhotosAlbum = ({data}) => {
 
          const ssr = data?.[0]?.albumsData || {}
          const {mobile,setMobile,containerRef} = useContext(DeviceContext)
          const d = ssr || {};
          const location = useLocation();
          const [albumData, setAlbumData] = useState(ssr.pictureData || []);
          let url = location.pathname
          const [loading, setLoading] = useState(false);
          const [error,setError] = useState(null)
             const [hydrate,setHydrate] = useState(true)
            let clean = url.substring(url.lastIndexOf('/') + 1, url.lastIndexOf('.html'));
             let parts = clean.split('-');
             let folderId = parts[parts.length - 1];
             let galleryId = parts[parts.length - 2];
             let catId = parts[parts.length - 3];
             let breadcrumbCat ={}
             const ssrFolderId = ssr.ssrFolderId
             switch (catId) {
                 case "1":
                 breadcrumbCat={name:"Actress",link:"/pages/actress-1.html"}
                 break;
                  case "2":
                  breadcrumbCat={name:"Actors",link:"/pages/actors-2.html"}
                 break;
                  case "10":
                  breadcrumbCat={name:"Events",link:"/pages/events-10.html"}
                 break;
                  case "11":
                  breadcrumbCat={name:"Kingsize",link:"/pages/kingsize-11.html"}
                 break;
                  case "8":
                  breadcrumbCat={name:"Movies",link:"/pages/movies-8.html"}
                 break;
                  case "12":
                  breadcrumbCat={name:"Others",link:"/pages/others-12.html"}
                 break;
                  case "9":
                 breadcrumbCat={name:"Wallpapers",link:"/pages/wallpapers-9.html"}
                 break;
             
               default:
                 break;
             }


             
      useEffect(() =>  {
     
           let start = setTimeout(() => { 
              setHydrate(false)     
           }, 500);
           return () => clearTimeout(start)
   
      },[])
              

   // -------- FETCH FUNCTION --------
    const fetchData = async () => {
    
    
      try {
       
        const res = await fetch(
          `https://teluguone.com/photos_api/photosFolderJson?folderId=${folderId}&start=${0}&limit=${20}`
        );
  
        const json = await res.json();
  
        const apiData = json?.photos_folder?.filter(item => !item.msg) || [];
        setAlbumData(apiData);
  
      } catch (err) {
        console.error("Fetch error:", err);
        setError(err.message)
      } finally {
        setLoading(false);
      }
  
    };
  
    useEffect(() => {
      if (ssr?.pictureData?.length > 0 && String(ssrFolderId) === folderId) {
         setLoading(false)
      } else {
        setLoading(true)
        setAlbumData([])
        fetchData();
      }
    }, [location.pathname]);
  


 
 
  return (
   
        <main className="photos-album">
        <Helmet><title>{albumData?.[0]?.folder_name || 'Telugu Photo Gallery'} Photos, HD Images & Gallery | TeluguOne</title></Helmet>
        <div className="alpha-filter">
                    <div className="breadcrumb">
                          <Link to="/">Home</Link> / <Link to={breadcrumbCat.link}>{breadcrumbCat.name}</Link>
                                <span> / </span>
                          <Link to={albumData?.[0]?.url_link ? albumData[0].url_link.substring(albumData[0].url_link.indexOf('/single')) : ''} >{albumData?.[0]?.folder_name || ''}</Link>
                     </div>
                    </div>
       

             
          <div className="gallery">
                    {(loading || hydrate) && Array(20).fill("0").map((i,index) => <Link key={index} to="" >
                           <Skeleton type={"gallery-skeleton-img"} />
                      </Link>)}
                    
                    { albumData && albumData.map((item,index) => <Link className={hydrate ? 'd-none' : ''} key={index} to={item.url_link ? item.url_link.substring(item.url_link.indexOf('/single')) : ''} >
                          <img src={item.stimg ? item.stimg : ''}  alt={item.folder_name ? item.folder_name : 'single-image'} loading={index === 0 ? 'eager' : 'auto'} />
                      </Link> ) }

                    {error && <p style={{width:"100%",textAlign:"center",fontWeight:"bold",color:"black"}}>No Json Data</p>}

           </div>


                   <SingleRelatedSection cat_id={catId} cat_name={" "} page={"album"} galId={galleryId} folderId={folderId}  />
                   <PageAds  mobile={mobile} containerRef={containerRef} />
       </main>
  )


}

export default PhotosAlbum;
